import { ButtonProps } from '@mui/material';

import { NavigationItem } from '../types';

export const getNotLinkButtonProps = (
  {
    StartIcon,
    amount,
    isActive,
    isComingSoon,
    isDisabled,
    isEnabled,
    isHidden,
    isNew,
    isNotLinkItem,
    onAccessDeniedClick,
    onClick,
    requiresPermission,
    ...props
  }: NavigationItem,
  hasAccess: boolean,
): ButtonProps => ({
  ...props,
  disabled: !isEnabled && !isComingSoon && (!props.href || isDisabled),
  href: undefined,
  onClick: hasAccess ? onClick : onAccessDeniedClick,
  variant: 'text',
});
